module.exports = __webpack_public_path__ + "static/img/HPC.be3b754.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HPC.png
// module id = tlHP
// module chunks = 78